import React from 'react';
import { createBrowserRouter, Outlet, RouteObject } from 'react-router-dom';

import ErrorBoundary from 'ui-lib/components/ErrorPage/ErrorBoundary';
import ThemeProvider from 'ui-lib/ThemeProvider';
import AuthPage from 'web-shared/modules/auth/pages/AuthPage';
import ForgotPasswordPage from 'web-shared/modules/auth/pages/ForgotPasswordPage';
import ResetPasswordPage from 'web-shared/modules/auth/pages/ResetPasswordPage';
import ProtectedRoute from 'web-shared/modules/auth/shared/components/ProtectedRoute';

export function createAppRouter({
  children,
  basename,
  mixedTheme,
}: {
  children: RouteObject[];
  mixedTheme: boolean;
  basename?: string;

}) {
  return createBrowserRouter(
    [
      {
        path: '/*',
        element: <ErrorBoundary enableCrashLogs mixedTheme={mixedTheme}>
          <Outlet />
        </ErrorBoundary>,
        children,
      },
    ],
    { basename },
  );
}

export function createProtectedAppRouter({
  basename,
  App,
  routes = [],
  mixedTheme,
}: {
  App: React.ComponentType;
  mixedTheme: boolean;
  basename?: string;
  routes?: RouteObject[];
}) {

  const renderElement = (element: React.ReactNode) => mixedTheme ?
    <ThemeProvider>{element}</ThemeProvider> : element;

  const router = createAppRouter({
    basename,
    mixedTheme,
    children: [
      {
        path: 'sign-in',
        element: renderElement(<AuthPage />),
      },
      {
        path: 'forgot-password',
        element: renderElement(<ForgotPasswordPage />),
      },
      {
        path: 'reset-password',
        element: renderElement(<ResetPasswordPage />),
      },
      ...routes,
      {
        path: '*',
        element: (
          <ProtectedRoute>
            <App />
          </ProtectedRoute>
        ),
      },
    ],
  });
  return router;
}
